import { render } from "./AppSubDemandHeader.vue?vue&type=template&id=56197064"
import script from "./AppSubDemandHeader.vue?vue&type=script&lang=js"
export * from "./AppSubDemandHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__